<section class="pdt30 pdb30 backDark noPrint">
    <div class="cw">
        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlign="space-between" FxLayoutGap="2rem"
            fxLayoutAlign.lt-lg="center center" fxFlex="100%">


            <!-- COL 1 -->
            <div fxLayout="column" fxFlex=100% fxLayoutAlign.lt-lg="center center">
                <h6 class="h6Title gray-7 ft15 ">Predyc</h6>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/"> Inicio </p>
                <!-- <p href="" class="mgt05 mgb0 lightLink" routerLink="/mis-cursos"> Mis cursos </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/mi-cuenta"> Mi cuenta </p> -->
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/buscar"> Explorar cursos </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/capacitacion-empresas"> Capacitación para empresa
                </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/ensena"> Enseña en Predyc </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/terminos-condiciones"> Términos y condiciones </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/politica-privacidad"> Política de privacidad </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/politica-cookies"> Política de cookies </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/faq"> FAQ </p>
                <p href="" class="mgt05 mgb0 lightLink" routerLink="/sign-in-instructor"> Iniciar sesión como instructor
                </p>
            </div>


            <!-- COL 2 -->
            <div fxLayout="column" fxFlex=100% fxLayoutAlign.lt-lg="center center">
                <h6 class="h6Title gray-7 ft15 ">Categorías</h6>
                <div *ngFor="let item of categoriasContadas">
                    <p *ngIf="item.cant != 0" class="mgt05 mgb0 lightLink" (click)="buscarCategoria(item.categoria)">
                        {{item.categoria}}</p>
                </div>
            </div>


            <!-- COL 3 -->
            <div fxLayout="column" fxFlex=100% fxLayoutAlign.lt-lg="center center">
                <h6 class="h6Title gray-7 ft15 ">Contacto</h6>
                <div class="mgt10">
                    <a href="tel:+529932872551" class="lightLink">
                        <div fxLayout="row" fxLayoutAlign=" center lightLink">
                            <mat-icon> phone</mat-icon>
                            <span class="mgl05 lightLink"> +52 993 2872551</span>
                        </div>
                    </a>
                </div>
                <div class="mgt10">
                    <a href="mailto:contacto@predyc.com" class="lightLink">
                        <div fxLayout="row" fxLayoutAlign=" center lightLink">
                            <mat-icon> email </mat-icon>
                            <span class="mgl05 lightLink"> contacto@predyc.com</span>
                        </div>
                    </a>
                </div>
                <div class="mgt10">
                    <a  class="lightLink">
                        <div fxLayout="row" fxLayoutAlign=" center lightLink">
                            <mat-icon> location_on </mat-icon>
                            <span class="mgl05 lightLink"> Querétaro, México</span>
                        </div>
                    </a>
                </div>
                <div class="mgt10">
                    <a href="" routerLink="/soporte" class="lightLink">
                        <div fxLayout="row" fxLayoutAlign=" center lightLink">
                            <mat-icon> headset_mic </mat-icon>
                            <span class="mgl05 lightLink"> Ayuda y soporte técnico</span>
                        </div>
                    </a>
                </div>
            </div>


            <!-- COL 4 -->
            <div fxLayout="column" fxFlex=100% fxLayoutAlign.lt-lg="center center">
                <h6 class="h6Title gray-7 ft15 ">Síguenos</h6>
                <div fxLayout="row" fxLayoutGap="1rem">
                    <a href="https://www.facebook.com/Predyc/" target="_blank" class="lightLink ft18">
                        <i class="fab fa-facebook"></i>
                    </a>
                    <a href="" target="_blank" class="lightLink ft18">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="" target="_blank" class="lightLink ft18">
                        <i class="fab fa-youtube"></i>
                    </a>
                    <a href="https://mx.linkedin.com/showcase/predyc" target="_blank" class="lightLink ft18">
                        <i class="fab fa-linkedin"></i>
                    </a>
                </div>
            </div>


        </div>
    </div>
</section>